'use client';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Root as Root2, Trigger, Content as Content2, Arrow as Arrow2 } from './../../../external/@radix-ui/react-popover/dist/index.js';
import { useState } from 'react';

const Popover = ({ asChild, content, children, disablePopover, side = 'top', triggerOnHover = true, disableAutoFocus, darkMode = true, }) => {
    const [open, setOpen] = useState(false);
    return disablePopover ? (jsx(Fragment, { children: children })) : (jsxs(Root2, { open: open, onOpenChange: setOpen, children: [jsx(Trigger, { className: "focus-visible:outline-none", asChild: asChild, onMouseOver: () => triggerOnHover && setOpen(true), onMouseOut: () => triggerOnHover && setOpen(false), children: children }), jsxs(Content2, { className: `rounded-lg p-4 text-sm shadow-sm focus-visible:outline-none ${darkMode
                    ? 'bg-leland-gray-dark text-white'
                    : 'border border-leland-gray-stroke bg-white text-leland-gray-dark'}`, side: side, sideOffset: 4, onOpenAutoFocus: (event) => {
                    if (disableAutoFocus) {
                        event.preventDefault();
                    }
                }, children: [content, jsx(Arrow2, { className: darkMode ? 'fill-leland-gray-dark' : 'fill-leland-gray-stroke' })] })] }));
};

export { Popover };
//# sourceMappingURL=popover.js.map
